import T, { t } from '../../../../common/components/T';
import { replaceUrl } from '../../../../common/utils/router';
import css from './RegisterView.module.scss';
import uikit from '../../../../project/uikit/styles';
import classNames from 'classnames';

export const getFormFields = (data = {}, isRefer, isOfficeRegister) => {
    return [
        {
            attribute: 'sponsor_username',
            type: 'input',
            title: {
                body: <T textName='register-fields-sponsor-username-title' defaultStr='ID спонсора' page='/authentication' />
            },
            placeholder: (
                <T textName='register-fields-sponsor-username-placeholder' defaultStr='KAZ001180100002' page='/authentication' />
            ),
            required: true,
            value: data?.data?.sponsor_username,
            disabled: isRefer
        },
        {
            attribute: 'sponsor_lastname',
            type: 'input',
            title: {
                body: (
                    <T
                        textName='register-fields-sponsor-username-lastname-title'
                        defaultStr='Фамилия спонсора'
                        page='/authentication'
                    />
                )
            },
            disabled: true,
            value: data?.data?.last_name
        },
        {
            attribute: 'sponsor_firstname',
            type: 'input',
            title: {
                body: (
                    <T
                        textName='register-fields-sponsor-username-firstname-title'
                        defaultStr='Имя спонсора'
                        page='/authentication'
                    />
                )
            },
            disabled: true,
            value: data?.data?.first_name
        },
        {
            attribute: 'line',
            type: 'info-field',
            html: <div className={css.line}></div>
        },
        // {
        //     placeholder: 'johndoe',
        //     attribute: 'username',
        //     required: true,
        //     title: {
        //         body: <T textName='register-fields-username-title' defaultStr='Ваш логин' page='/authentication' />
        //     },
        //     type: 'input'
        // },
        ...(isOfficeRegister
            ? [
                  {
                      type: 'radio-list',
                      attribute: 'structure_position',
                      options: [
                          {
                              value: 1,
                              title: <T textName='left-branch' defaultStr='Левая ветка' />
                          },
                          {
                              value: 2,
                              title: <T textName='right-branch' defaultStr='Правая ветка' />
                          }
                      ],
                      title: {
                          body: (
                              <T
                                  textName='register-branch'
                                  defaultStr='Ветка для постановки нового пользователя'
                                  page='/authentication'
                              />
                          ),
                          hint: (
                              <T
                                  textName='register-branch-title-hint'
                                  defaultStr='Пользователь займет место в структуре после успешной оплаты регистрационного пакета'
                                  page='/authentication'
                              />
                          )
                      }
                  }
              ]
            : []),
        {
            attribute: 'country_id',
            required: true,
            type: 'location_widget',
            title: {
                body: <T textName='register-fields-country-title' defaultStr='Выберите страну' page='/authentication' />
            }
        },
        {
            attribute: 'last_name',
            type: 'input',
            required: true,
            title: {
                body: <T textName='register-fields-lastname-title' defaultStr='Введите фамилию' page='/authentication' />
            }
        },
        {
            attribute: 'first_name',
            type: 'input',
            required: true,
            title: {
                body: <T textName='register-fields-firstname-title' defaultStr='Введите имя' page='/authentication' />
            }
        },
        {
            attribute: 'line',
            type: 'info-field',
            html: <div className={css.line}></div>
        },
        {
            attribute: 'email',
            required: true,
            title: {
                body: <T textName='register-fields-email-title' defaultStr='Введите email' page='/authentication' />
            },
            type: 'input'
        },
        // checkCodeEmail
        //     ? {
        //           placeholder: 'Email code',
        //           attribute: 'code',
        //           required: true,
        //           title: {
        //               body: <T textName='register-fields-code-title' defaultStr='Введите код из email' page='/authentication' />
        //           },
        //           type: 'input'
        //       }
        //     : false,
        {
            placeholder: '******',
            attribute: 'password',
            required: true,
            title: {
                body: <T textName='getFormData-password-title' defaultStr='Введите пароль' page='/authentication' />
            },
            type: 'password',
            hint: (
                <T
                    textName='getFormData-password-tooltip'
                    defaultStr='Данное поле должно содержать только латинские символы, цифры, а также спец. символы. Минимальная длина данного поля должна быть от 6 символов.'
                    page='/authentication'
                />
            )
        },
        {
            placeholder: '******',
            attribute: 'password_confirmation',
            required: true,
            title: {
                body: (
                    <T
                        textName='register-fields-password_confirmation-title'
                        defaultStr='Подтвердите пароль'
                        page='/authentication'
                    />
                )
            },
            type: 'password'
            // tooltip: <T textName='register-fields-password_confirmation-tooltip' defaultStr='Значение поля должно соотвествовать значению поля "Пароль".' page='/authentication' />
        },
        {
            name: 'email_verification_client_url',
            attribute: 'email_verification_client_url',
            value: replaceUrl('/verify'),
            type: 'input'
        }
    ].filter((i) => i != false);
};

export const getFormStyles = (isOfficeRegister) => ({
    email_verification_client_url: { wrapper: { display: 'none' } },
    agreement: {
        label: {
            alignItems: 'flex-start',
            ...uikit.small,
            lineHeight: '1.28',
            marginBottom: 0
        },
        wrapper: css.agreementWrapper
    },
    agrees: {
        wrapper: classNames('registerAgreement', css.agreementWrapper),
        listTitle: 'registerAgreement'
    },
    line: { wrapper: css.lineWrapper },
    structure_position: {
        wrapper: {
            className: css.structurePositionWrapper
        }
    },
    ...(isOfficeRegister
        ? {
              password_confirmation: {
                  wrapper: css.passwordConfirmationWrapper
              }
          }
        : {})
});

export const checkUserToken = (data, afterConfirm, setAllowedSend, setUserToken, setAlertData, translation) => {
    const token = data?.data?.token;

    if (token) {
        setUserToken(token);
        afterConfirm && afterConfirm(token);
    } else {
        setAlertData({
            type: 'error',
            cont: t('authentication', 'Неверный токен', '/authentication', translation)
        });
        setAllowedSend(true);
    }

    return true;
};
